'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index_es = require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
var Button_web = require('../Button/Button.web.cjs');
var Skeleton_web = require('../Skeleton/Skeleton.web.cjs');
var IconButton_web_styles = require('./IconButton.web.styles.cjs');

/**
 * A button component that displays an icon
 *
 * @scope: Core
 */ const IconButton = ({ icon, size = "medium", isLoading = false, customCss, ...buttonProps })=>{
    const buttonStyles = [
        IconButton_web_styles.size[size],
        customCss
    ];
    if (isLoading) {
        return /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
            width: IconButton_web_styles.iconButtonSizes[size].width,
            height: IconButton_web_styles.iconButtonSizes[size].height
        });
    }
    return /*#__PURE__*/ jsxRuntime.jsx(Button_web.Button, {
        customCss: buttonStyles,
        ...buttonProps,
        children: /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
            icon: icon,
            css: IconButton_web_styles.icon
        })
    });
};

exports.IconButton = IconButton;
//# sourceMappingURL=IconButton.web.cjs.map
